import { render, staticRenderFns } from "./SITataUsaha.vue?vue&type=template&id=b385085a&"
import script from "./SITataUsaha.vue?vue&type=script&lang=js&"
export * from "./SITataUsaha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports